import { bloomFragmentColumn } from "../resource/bloom-fragment-column";
import { NeededColumn } from "./needed-column";

export const bloomFragmentNeededColumn = new NeededColumn(
  "71d321e8-c9c0-4f28-8a32-0a49f920d99b",
  bloomFragmentColumn,
  "Bloom Frag Needed"
)
